import axiosInstance from './axiosInstance';

export const sendNotification = async (data) => {
  const payload = {
    to_email: data?.to_email || 'etlcoreemail@gmail.com',
    subject: data?.subject,
    message: data?.message,
    workflow_id: data?.workflow_id,
    workflow_name: data?.workflow_name,
    status: data?.status || 'STARTED',
  };
  const res = await axiosInstance.post('/email/send-notification', payload);
  return res.data;
};


